import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

// `silent` нь http-handler-ийн toast-ыг хаана: алдааг маягт өөрөө харуулдаг дуудагч ашиглана.
type Extras = { silent?: boolean };

type IOtp = {
  otpMethod: string;
};

export const get = async (data: IOtp, extras?: Extras) => {
  const res = await httpRequest.get("/2fa/auth/otp", data, extras);
  return res;
};

export const verify = async (data: { otpMethod: string; otpCode: string | number }, extras?: Extras) => {
  const res = await httpRequest.post(`/2fa/auth/otp/verify`, data, extras);
  return res;
};

export const phoneCheck = async (data: { otpMethod: string; phone: string }, extras?: Extras) => {
  const res = await httpRequest.get(`/2fa/auth/otp/phone_check`, data, extras);
  return res;
};

export const registerVerify = async (data: { verifyId: string; otpCode: string }, extras?: Extras) => {
  const res = await httpRequest.post(`/2fa/auth/otp/register_verify`, data, extras);
  return res;
};
